new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: true,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if(photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        singlePhotoItem.forEach((content) => {
                          content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }
    
                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                          activeTab(index);
                        });
                    });
                }
            }

            if(photoThumbs) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }

        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    const variations = document.querySelector('.product-detail__header--infoArea-kit .product-radio-variation');
    if(variations) {
        const variationItem = variations.querySelectorAll('label');
        if(variationItem.length) {
            variationItem.forEach((item) => {
                item.addEventListener('click', () => {
                    setTimeout(() => {
                        const keepingBuyContent = document.querySelector('.keeping-buying__content');
                        if (keepingBuyContent) {
                            const NameProduct = keepingBuyContent.querySelector('#js-product_name__product_detail_keeping_buying');
                            if (NameProduct) {
                                const productName = NameProduct.textContent;
                                const words = productName.trim().split(' ');
                                const lastTwoWords = words.slice(-2).join(' ');
                                const matchNumbers = lastTwoWords.match(/\d+/g);
                                if (matchNumbers && matchNumbers.length > 0) {
                                    NameProduct.textContent = matchNumbers.join(' ');
                                }
                            }
                        }
                    }, 1000)
                });
            });
        }
    }

    $("body").on("submit", "[id^='js-produto_notify_not_available__product_detail_'] #form_notify_not_available_product", function (event) {
        event.preventDefault();
        
        var form = $(this);
        console.log(form);
        var email = form.find("#email_notify").val();
        console.log(email);
        var properties = form.find('input[name^="properties["]').serializeArray();
        console.log(properties);
        var propertiesObj = {}
        console.log(propertiesObj);
        $.each(properties, function(i, field){
            propertiesObj[field.name] = field.value;
        });
        var produto_id = form.find("#product_notify").val();
        console.log(produto_id);
        
        console.log(email, propertiesObj, produto_id);
        product_detail_service.notify('', email, propertiesObj, produto_id);
    });

    if (window.matchMedia("(min-width: 992px)").matches) {
        let lastScrollTop = 0;
    
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            if (photoScroll) {
                $('.sidebar__inner').css({position: 'fixed'});
                const containerWidth = $('.product-detail__header--infoArea').width();
                $('.sidebar__inner').css({"maxWidth": containerWidth + "px"});
                const sidebarHeight = $('.product-detail__header--infoArea').height();
                const heightTop = $('.sidebar__inner').height();
                const totalHeight = sidebarHeight - heightTop;
                const pageTop = window.scrollY;
    
                // Check scroll direction
                if (pageTop > lastScrollTop) {
                    // Scrolling down
                    $('.sidebar__inner').css({top: "0px"});
                } else {
                    // Scrolling up
                    $('.sidebar__inner').css({top: "initial"});
                }
    
                if (pageTop >= totalHeight) {
                    $('.sidebar__inner').css({top: totalHeight + "px"});
                    $('.sidebar__inner').css({position: 'relative'});
                    $('.sidebar__inner').css({"maxWidth": "100%"});
                } else {
                    $('.sidebar__inner').css({position: 'fixed'});
                    $('.sidebar__inner').css({"maxWidth": containerWidth + "px"});
                }
    
                lastScrollTop = pageTop;
            }
        }
    
        window.addEventListener('scroll', function() {
            if (screen.width > 991) {
                const photoScroll = document.querySelector('.product-detail__header--photoArea');
                if (photoScroll) {
                    animeScroll();
                }
            }
        });
    
        window.onresize = function() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            if (photoScroll) {
                if ($('.sidebar__inner').css({position: 'fixed'})) {
                    const containerWidth = $('.product-detail__header--infoArea').width();
                    $('.sidebar__inner').css({"maxWidth": containerWidth + "px"});
                }
            }
        };
    }    

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('.product-detail__related--items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      speed: 700,
      vertical: false,
      responsive: [
          {
              breakpoint: 991,
              settings: {
                slidesToShow: 4,
                arrows: true,
              }
          },
      ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    // $('.product__colors.attribute').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     infinite: false,
    //     mobileFirst: true,
    //     speed: 700,
    //     vertical: false,
    // })

    $('#photo-fancy').fancybox();

    const updateFreight = (selector) => {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
            }
        
            //Init observer to wait element exist in DOM
            const observer = new MutationObserver(() => {
              if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                //Disconnect observer after find element
                animeScroll()
              }
            });
            
            //Set observer to watch all element inside body
            observer.observe(document.body, {
              subtree: true,
              childList: true,
            });
        });
    }

    updateFreight('#js_shipping_calculation_table_body > *')

})